import {
	START_PASSWORDLESS_FLOW,
	START_PASSWORDLESS_FLOW_FAIL,
	PasswordlessFlowType,
  } from "../../domain/phoneFlow/index";
import {  passwordlessClient } from "../../api/passwordlessClient";
import { ICommandResult } from "../../../Common/domain/src/api/commandResult";
import { IPasswordlessSMSFlowCommand } from "../../../Common/domain/src/api/command";

  // in actions folder
  export const startPasswordlessFlowAction = (
	result: ICommandResult
  ): PasswordlessFlowType => {
	return {
	  type: START_PASSWORDLESS_FLOW,
	  payload: result,
	};
  };
  
  export const startPasswordlessFailAction = (
	err: ICommandResult
  ): PasswordlessFlowType => {
	return {
	  type: START_PASSWORDLESS_FLOW_FAIL,
	  payload: err,
	};
  };

  export const handleStartPasswordlessFlow = (token: string, command: IPasswordlessSMSFlowCommand) => {
	return function (dispatch: any) {
	  const endpoint = new passwordlessClient();
	  endpoint
		.startPasswordlessFlow(token, command)
		.then((data) => {
		  dispatch(startPasswordlessFlowAction(data));
		  return data;
		})
		.catch((err) => {
		  dispatch(startPasswordlessFailAction(err));
		});
	};
  };
 